<template>
  <div>
    <div class="contract">
      <Header
        v-if="!checkCreatedDateNganluong(dataAppendix)"
        :groupService="dataContract.groupService"
      ></Header>
      <HeaderNL v-else :groupService="dataContract.groupService"></HeaderNL>
      <p class="txt-center fonsize-16 txt-tranf">CỘNG HÒA XÃ HỘI CHỦ NGHĨA VIỆT NAM</p>
      <p class="txt-center fonsize-16">Độc lập – Tự do – Hạnh phúc</p>
      <p class="txt-center fonsize-16">***</p>

      <p class="txt-tranf txt-center fonsize-20">
        <b>BIÊN BẢN CHUYỂN NHƯỢNG THIẾT BỊ THANH TOÁN</b>
      </p>
      <p class="txt-center">
        (Số:
        <mark>{{ dataAppendix.code }}</mark>
        )
      </p>
      <p>Căn cứ:</p>
      <ol class="form-style2">
        <li>
          Hợp đồng số: <mark>{{ dataContract.code }}</mark>
          <p>
            ký ngày
            <mark>{{
              dataContract.effectiveFromDTO
                ? dataContract.effectiveFromDTO
                : dataContract.dateSign | formatDate
            }}</mark>
            {{
              checkCreatedDateNganluong(dataAppendix)
                ? 'giữa CÔNG TY CỔ PHẦN CỔNG TRUNG GIAN THANH TOÁN NGÂN LƯỢNG và'
                : 'giữa CÔNG TY CỔ PHẦN CÔNG NGHỆ VI MÔ và'
            }}
            <mark
              ><b>{{ customerInfo.merchantName }}</b></mark
            >
          </p>
        </li>
      </ol>
      <p>
        Hôm nay, ngày
        <mark v-if="dataAppendix.dateSignAppendixDTO">{{
          dataAppendix.dateSignAppendixDTO | formatDate
        }}</mark>
        <mark v-else-if="dataAppendix.dateCreatedAppendixDTO">{{
          dataAppendix.dateCreatedAppendixDTO | formatDate
        }}</mark>
        <mark v-else-if="dataContract.effectiveFromDTO">{{
          dataContract.effectiveFromDTO | formatDate
        }}</mark>
        ,
        {{
          checkCreatedDateNganluong(dataAppendix)
            ? 'tại trụ sở Công ty Cổ phần cổng trung gian thanh toán Ngân Lượng, chúng tôi gồm có:'
            : 'tại trụ sở Công ty Cổ phần Công nghệ Vi Mô, chúng tôi gồm có:'
        }}
      </p>
      <p class="fonsize-16 txt-tranf">
        <b>
          BÊN A: <mark>{{ customerInfo.merchantName }}</mark>
        </b>
      </p>
      <p>
        Địa chỉ:
        <b>
          {{ customerInfo.address && `${customerInfo.address}` }}
          {{ customerInfo.district && `, ${customerInfo.district}` }}
          {{ customerInfo.city && `, ${customerInfo.city}` }}
        </b>
      </p>
      <ul class="form">
        <li>Điện thoại: {{ customerInfo.mobile }}</li>
        <li>Mã số thuế: {{ customerInfo.businessRegistrationNumber }}</li>
        <li>Đại diện: {{ customerInfo.customerName }}</li>
        <li>
          Chức vụ: <b>{{ customerInfo.position }}</b>
        </li>
      </ul>
      <p class="fonsize-16 txt-tranf flex">
        <span> <b>BÊN B:</b></span>
        <mark
          ><b>{{
            dataAppendix.appendixTransfer && dataAppendix.appendixTransfer.merchantName
          }}</b></mark
        >
      </p>
      <p><b>(sau đây được gọi là “BÊN B”)</b></p>
      <p>
        <span>Địa chỉ trụ sở: </span>
        {{ dataAppendix.appendixTransfer && dataAppendix.appendixTransfer.address }}
      </p>
      <p>
        <span>Mã số thuế: </span>
        {{
          dataAppendix.appendixTransfer && dataAppendix.appendixTransfer.businessRegistrationNumber
        }}
      </p>
      <p>
        <span>Người đại diện:</span>
        {{ dataAppendix.appendixTransfer && dataAppendix.appendixTransfer.customerName }}
      </p>
      <p>
        <span>Chức vụ:</span>
        {{ dataAppendix.appendixTransfer && dataAppendix.appendixTransfer.position }}
      </p>

      <p>&nbsp;</p>
      <p>
        Hai bên cùng thống nhất chuyển nhượng và nhận chuyển nhượng thiết bị thuộc hợp đồng Dịch vụ
        thanh toán số
        <mark>{{ dataContract.code }}</mark
        >và các phụ lục hợp đồng đi kèm với những nội dung như sau:
      </p>
      <ol style="padding: 10px 0 0 10px !important">
        <li>
          <h1 style="font-size: 16px"><b> Nội dung chuyển nhượng</b></h1>
          <ul class="form-style2" style="counter-reset: none">
            <li>
              <b>Bên A</b> xác nhận đã bàn giao đầy đủ thiết bị cho <b>Bên B</b> với tình trạng
              thiết bị còn hoạt động và sử dụng được bình thường theo đúng tiêu chuẩn chất lượng của
              nhà sản xuất và đơn vị cung cấp.
            </li>
            <li>Danh sách các thiết bị mà Bên A chuyển nhượng lại cho Bên B cụ thể như sau:</li>
            <li style="list-style: none">
              <div class="table-responsive">
                <table class="table">
                  <thead>
                    <tr class="bg-head">
                      <th align="center">STT</th>
                      <th align="center">Serial thiết bị</th>
                      <th align="center">Loại thiết bị</th>
                      <th align="center">Tình trạng sử dụng</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr
                      v-for="(item, index) in dataAppendix.appendixTransfer.deviceTransfers"
                      :key="index"
                    >
                      <td align="center">{{ index + 1 }}</td>
                      <td>{{ item.device.serialNumber }}</td>
                      <td>
                        <div>
                          <span v-if="item.device.name === 'PR_02'">
                            <input style="width: auto" :checked="true" type="checkbox" />
                            mPOS
                          </span>
                          <span v-if="item.device.name === 'SMART_POS'">
                            <input style="width: auto" :checked="true" type="checkbox" />
                            SmartPOS
                          </span>
                        </div>
                      </td>
                      <td>{{ item.status }}</td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </li>
          </ul>
        </li>

        <li>
          <h1 style="font-size: 16px"><b>Điều khoản thi hành</b></h1>

          <ol class="form-style2">
            <li>
              Việc Bên A ký kết với Bên B biên bản chuyển nhượng thiết bị này đồng nghĩa là Bên A sẽ
              không còn bất kỳ quyền lợi, nghĩa vụ và trách nhiệm nào với hợp đồng Dịch vụ thanh
              toán số
              <mark>{{ dataContract.code }}</mark
              >.
            </li>
            <li>
              Với việc Bên B nhận chuyển nhượng thiết bị từ Bên A theo các nội dung nêu tại Điều 1
              có nghĩa Bên B chấp thuận ký kết lại hợp đồng Dịch vụ thanh toán số
              <mark>{{ dataContract.code }}</mark
              >.
            </li>
            <li>
              Văn bản này được lập thành 02 bản, bằng tiếng Việt với nội dung và giá trị pháp lý như
              nhau, mỗi bên giữ 01 bản để cùng thi hành.
            </li>
          </ol>
        </li>
      </ol>
      <Footer
        v-if="!checkCreatedDateNganluong(dataAppendix)"
        :dataContract="dataContract"
        :dataAppendix="dataAppendix"
        :isAppendix="true"
      ></Footer>
      <FooterNL
        v-else
        :dataContract="dataContract"
        :dataAppendix="dataAppendix"
        :isAppendix="true"
      ></FooterNL>
    </div>
  </div>
</template>

<script>
  import Header from '../block/header.vue'
  import Footer from '../block/footer.vue'
  import HeaderNL from '../block/headerNL.vue'
  import FooterNL from '../block/footerNL.vue'
  export default {
    props: ['dataContract', 'appendix'],
    components: {
      Header,
      Footer,
      HeaderNL,
      FooterNL,
    },
    data() {
      return {}
    },
    computed: {
      customerInfo() {
        return this.dataContract.customerInfoRes ?? this.dataContract.customerInfoCommon ?? {}
      },
      dataAppendix() {
        return this.appendix
      },
    },
  }
</script>

<style scoped src="@/assets/css/style-review.css"></style>
